import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPlannedStockStatus implements BaseEnumType {
  private static allValues: EnumPlannedStockStatus[] = []; // make sure this is top-most
  
  public static awaitingAction = new EnumPlannedStockStatus(0, "AwaitingAction", "enum_planned_stock_status_awaiting_action");
  public static awaitingFollowUp = new EnumPlannedStockStatus(1, "AwaitingFollowUp", "enum_planned_stock_status_awaiting_follow_up");
  public static complete = new EnumPlannedStockStatus(9, "Complete", "enum_planned_stock_status_complete");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPlannedStockStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isAwaitingAction() { return this === EnumPlannedStockStatus.awaitingAction; }
  public isAwaitingFollowUp() { return this === EnumPlannedStockStatus.awaitingFollowUp; }
  public isComplete() { return this === EnumPlannedStockStatus.complete; }

  public static getValues(): readonly EnumPlannedStockStatus[] {
    return EnumPlannedStockStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumPlannedStockStatus[] {
    return EnumPlannedStockStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPlannedStockStatus {
    const found = EnumPlannedStockStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPlannedStockStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPlannedStockStatus): EnumPlannedStockStatus {
    const found = name ? EnumPlannedStockStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPlannedStockStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPlannedStockStatus>): boolean {
    return this.key === other?.key;
  }
}